/* Dawn store-credit module */
(function () {
  'use strict';

  if (window.DDCartStoreCredit) return;

  var API_BASE = 'https://creditsyard.com/api/common';
  var APP_PROXY_BASE = '/apps/my-store-credit/api/common';
  var REFRESH_MS = 60 * 1000;
  var _cachedBalance = null;
  var _cachedAt = 0;
  var _initTimer = null;
  var _inflight = null;

  function getConfig() {
    return window.__DD_CREDIT || window.__MC26_CREDIT || null;
  }

  function getMoneyFormat() {
    return (
      window.shopMoneyFormat ||
      (window.Shopify && window.Shopify.money_format) ||
      (window.theme && window.theme.money_format) ||
      '${{amount}}'
    );
  }

  function formatDollars(dollars) {
    var cents = Math.round((parseFloat(dollars) || 0) * 100);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, getMoneyFormat());
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function formatCreditNote(balance) {
    return (
      '<span class="dd-store-credit-note__amount">' +
      formatDollars(balance) +
      '</span> store credit on your account. Redeems at checkout, not with a code here.'
    );
  }

  function showCredit(ui, balance) {
    var descEl = ui.querySelector('[data-dd-credit-desc]');
    if (descEl) descEl.innerHTML = formatCreditNote(balance);
    ui.hidden = false;
    ui.style.display = '';
  }

  function hideCredit(ui) {
    ui.hidden = true;
    ui.style.display = 'none';
  }

  function fetchBalance(config) {
    if (!config || !config.email || !config.apiKey) return Promise.resolve(0);
    return fetch(API_BASE + '/customers/get', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shop-Api-Key': config.apiKey,
      },
      body: JSON.stringify({ customer_email: config.email }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error(String(response.status));
        return response.json();
      })
      .then(function (data) {
        return parseFloat(data && data.balance) || 0;
      })
      .catch(function () {
        return fetch(APP_PROXY_BASE + '/customers/get', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ customer_email: config.email })
        })
          .then(function (response) {
            if (!response.ok) throw new Error(String(response.status));
            return response.json();
          })
          .then(function (data) {
            return parseFloat(data && data.balance) || 0;
          })
          .catch(function () {
            return 0;
          });
      });
  }

  function scheduleInit() {
    clearTimeout(_initTimer);
    _initTimer = setTimeout(init, 300);
  }

  function updateWidgets(balance) {
    var widgets = document.querySelectorAll('[data-dd-store-credit]');
    if (!widgets.length) return;

    Array.prototype.forEach.call(widgets, function (ui) {
      var liquidBalance = parseFloat(ui.getAttribute('data-credit-balance') || '0') || 0;
      var finalBalance = balance > 0 ? balance : liquidBalance;
      if (finalBalance > 0) showCredit(ui, finalBalance);
      else hideCredit(ui);
    });
  }

  function init() {
    var config = getConfig();
    if (!config || !config.email) {
      updateWidgets(0);
      return;
    }

    var now = Date.now();
    if (_cachedBalance != null && now - _cachedAt < REFRESH_MS) {
      updateWidgets(_cachedBalance);
      return;
    }

    if (_inflight) {
      _inflight.then(updateWidgets);
      return;
    }

    _inflight = fetchBalance(config)
      .then(function (balance) {
        _cachedBalance = parseFloat(balance) || 0;
        _cachedAt = Date.now();
        return _cachedBalance;
      })
      .catch(function () {
        _cachedBalance = 0;
        _cachedAt = Date.now();
        return 0;
      })
      .finally(function () {
        _inflight = null;
      });

    _inflight.then(updateWidgets);
  }

  document.addEventListener('drawer:opened', scheduleInit);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleInit);
  }

  window.DDCartStoreCredit = {
    init: init,
    scheduleInit: scheduleInit,
    fetchBalance: fetchBalance,
  };
})();
